import { render, staticRenderFns } from "./Cases.vue?vue&type=template&id=f9b3e49a&scoped=true"
var script = {}
import style0 from "./Cases.vue?vue&type=style&index=0&id=f9b3e49a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b3e49a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9b3e49a')) {
      api.createRecord('f9b3e49a', component.options)
    } else {
      api.reload('f9b3e49a', component.options)
    }
    module.hot.accept("./Cases.vue?vue&type=template&id=f9b3e49a&scoped=true", function () {
      api.rerender('f9b3e49a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/mac-version/components/Cases.vue"
export default component.exports